import ProjectPreview from "../Components/ProjectPreview";

function Home() {
return (
<>
    <section className="banner_section banner_section_padding">
    <div className="md_wrapper">
        <div className="profile_image">
            <img 
                src="/Images/Profile.jpg" 
                alt="Aryan Antal"
            />
        </div>
        <div className="text_container">
            <h1>Scalable Full Stack Architectures. Custom HubSpot Solutions.</h1>
            <p>I engineer high-performance e-commerce platforms using Next.js & MERN and build complex,
                 editable themes for the HubSpot CMS. Bridging the gap between technical power and
                  marketing flexibility.</p>
            <a
                href="https://drive.google.com/file/d/1H9crBoHWFWySRgASzmO_xQ9U6JuFnbQd/view?usp=drivesdk"
                download
                className="cta_button"
                >
                Download Engineer Resume
            </a>
        </div>
    </div>
    </section>

    <section className="project_section section_padding">
        <div className="wrapper">
            <div className="align_center all_text_white mb-20">
                <h2>Featured Projects</h2>
            </div>
          <ProjectPreview />
        </div>
    </section>

    <section className="cta_section section_padding bg_dark all_text_white align_center">
        <div className="md_wrapper">
            <h2>Like what you see?</h2>
            <p>Explore more of my work or download my resume to get in touch.</p>
            <div className="buttons_container">
            <a href="/projects" className="cta_button White">
                Explore more
            </a>
            <a href="https://drive.google.com/file/d/1H9crBoHWFWySRgASzmO_xQ9U6JuFnbQd/view?usp=drivesdk" className="cta_button white border">
                Download resume
            </a>
            </div>
        </div>
    </section>
</>
);
}

export default Home;
